module.exports = require("./zen-observable.js").Observable;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/apollo-client/~/apollo-link/~/zen-observable/index.js
// module id = 854
// module chunks = 168707334958949